import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useEffect } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import filters from "../img/filters.png";
import gtip1 from "../img/gtip1.png";
import gtip2 from "../img/gtip2.png";
import tip1 from "../img/tip1.png";
import tip2 from "../img/tip2.png";
import tip3 from "../img/tip3.png";
import tip4 from "../img/tip4.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",

      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
    "& ul": { marginLeft: "20px" },
    "& li": {
      marginLeft: "20px",
    },
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "250px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  imgExplainerText: {
    fontWeight: "700",
  },
}));

function TipsIncreaseHandwriting() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Tips to increase handwriting recognition accuracy
        </Typography>
      </div>
      <div display="block">
        <div>
          <Typography
            display="block"
            className={classes.details}
            variant="body2"
          >
            To reduce your amount of manual grading, please stress to your
            students to:
          </Typography>
          <br />
          <Typography
            display="block"
            className={classes.imgExplainerText}
            variant="body2"
          >
            Write with large and neat characters:
          </Typography>
          <img className={classes.imgSize3} src={tip3} alt="Custom Tip 1" />
          <br />
          <Typography
            display="block"
            className={classes.imgExplainerText}
            variant="body2"
          >
            Print characters(do not write cursive):
          </Typography>
          <img className={classes.imgSize3} src={tip1} alt="Custom Tip 2" />
          <br />
          <Typography
            display="block"
            className={classes.imgExplainerText}
            variant="body2"
          >
            Write inside the box:
          </Typography>
          <img className={classes.imgSize3} src={tip2} alt="Custom Tip 3" />
          <br />
          <Typography
            display="block"
            className={classes.imgExplainerText}
            variant="body2"
          >
            Completely erase mistakes:
          </Typography>
          <img className={classes.imgSize3} src={tip4} alt="Custom Tip 4" />
        </div>
      </div>
    </div>
  );
}
function HowAccurate() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          How accurate is SwiftGrade’s handwriting recognition?
        </Typography>
      </div>
      <div display="block">
        <div>
          <Typography className={classes.details} variant="body2">
            Our handwriting recognition, including the recognition of math
            formulas is remarkably accurate. For neat handwriting, our accuracy
            rate is around 98%. For messy writing, unfortunately even giants
            like Google and Microsoft struggle with accuracy.
            <br />
            <br />
            However, we knew from day one that students write messily, and we
            never designed SwiftGrade thinking that we would achieve 100%
            accuracy. Instead, we designed SwiftGrade to reduce your grading
            load for handwritten assessments by 80-90%.
            <br />
            <br />
            The way this is done is that SwiftGrade flags answers with ‘low
            recognition confidence’. You can easily filter to view only these
            answers, and thus grade just a fraction of your total grading load.
          </Typography>
        </div>
      </div>
    </div>
  );
}
function TipsIncreaseMultipleChoice() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Tips to increase multiple-choice bubble recognition accuracy
        </Typography>
      </div>
      <div display="block">
        <div>
          <Typography
            display="block"
            className={classes.details}
            variant="body2"
          >
            To maximize grading accuracy, please tell students to:
          </Typography>
          <br />
          <Typography
            display="block"
            className={classes.imgExplainerText}
            variant="body2"
          >
            Fill circles fully:
          </Typography>
          <img
            style={{ maxWidth: "300px" }}
            className={classes.imgSize3}
            src={gtip1}
            alt="Custom Tip 1"
          />
          <br />
          <Typography
            display="block"
            className={classes.imgExplainerText}
            variant="body2"
          >
            Use dark color pen or pencil:
          </Typography>
          <img
            style={{ maxWidth: "200px" }}
            className={classes.imgSize3}
            src={gtip2}
            alt="Custom Tip 2"
          />
        </div>
      </div>
    </div>
  );
}
function WhatifIncorrect() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          What if SwiftGrade incorrectly recognizes student handwriting?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          Our handwriting recognition, including the recognition of math
          formulas is remarkably accurate. For neat handwriting, our accuracy
          rate is around 98%. For messy writing, unfortunately even giants like
          Google and Microsoft struggle with accuracy.
          <br />
          <br />
          However, we knew from day one that students write messily, and we
          never designed SwiftGrade thinking that we would achieve 100%
          accuracy. Instead, we designed SwiftGrade to reduce your grading load
          for handwritten assessments by 80-90%.
          <br />
          <br />
          The way this is done is that SwiftGrade flags answers with ‘low
          recognition confidence’. You can easily filter to view only these
          answers, and thus grade just a fraction of your total grading load.
          <br />
          <br />
          As an example, if 20 students took a 20 question quiz, that’s a total
          of 400 answers. Now if SwiftGrade flagged 40 answers, you only need to
          grade 10% of the original grading load.
          <br />
          <br />
          Here is a screenshot of our filters tool:
          <img
            style={{ boxShadow: "none", maxWidth: "425px" }}
            className={classes.imgSize2}
            src={filters}
            alt="Filters"
          />
        </Typography>
      </div>
    </div>
  );
}
function MaxScanAccuracy() {
  useEffect(() => {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = "https://fast.wistia.com/embed/medias/l6stp98wcn.jsonp";
    script1.async = true;

    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div style={{ display: "inline-block" }}>
        <div>
          <Typography variant="h5" className={classes.fontHeading}>
            Tutorial video: How to scan student answer sheets
          </Typography>
        </div>
        <Typography className={classes.details} variant="body2">
          This video shows you how avoid blurry images while scanning and thus
          maximize grading accuracy:
        </Typography>
        <div style={{ margin: "0 auto", maxWidth: "300px", height: "650px" }}>
          <div
            className="wistia_responsive_padding"
            style={{ padding: "207.81% 0 0 0", position: "relative" }}
          >
            <div
              className="wistia_responsive_wrapper"
              style={{
                height: "100%",
                boxShadow: "0 3px 10px rgb(0 0 0 / 0.5)",
                borderRadius: "4px",
                left: 0,
                position: "absolute",
                top: 0,
                width: "100%",
                marginBottom: "30px",
                marginTop: "30px",
              }}
            >
              <div
                className="wistia_embed wistia_async_l6stp98wcn seo=false videoFoam=true"
                style={{ height: "100%", position: "relative", width: "100%" }}
              >
                <div
                  className="wistia_swatch"
                  style={{
                    height: "100%",
                    left: 0,
                    opacity: 0,
                    overflow: "hidden",
                    position: "absolute",
                    top: 0,
                    transition: "opacity 200ms",
                    width: "100%",
                  }}
                >
                  <img
                    src="https://fast.wistia.com/embed/medias/l6stp98wcn/swatch"
                    style={{
                      filter: "blur(5px)",
                      height: "100%",
                      objectFit: "contain",
                      width: "100%",
                    }}
                    alt=""
                    aria-hidden="true"
                    onload="this.parentNode.style.opacity=1;"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function HandwritingTopics() {
  const { path } = useRouteMatch();
  return (
    <>
      <Switch>
        <Route path={`${path}/tips-increase-accuracy-handwriting`}>
          <TipsIncreaseHandwriting />
        </Route>
        <Route path={`${path}/tips-to-increase-multiple`}>
          <TipsIncreaseMultipleChoice />
        </Route>
        <Route path={`${path}/what-if-incorrect`}>
          <WhatifIncorrect />
        </Route>
        <Route path={`${path}/maximum-scan-accuracy`}>
          <MaxScanAccuracy />
        </Route>
        <Route path={`${path}/how-accurate-is-swiftgrade`}>
          <HowAccurate />
        </Route>
        <Route>
          <TipsIncreaseHandwriting />
        </Route>
      </Switch>
    </>
  );
}

export default HandwritingTopics;
